import { render, staticRenderFns } from "./About.vue?vue&type=template&id=12ff06cb&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=12ff06cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff06cb",
  null
  
)

export default component.exports